import { FormLabel } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import {
    DateRange,
    DateRangeValidationError,
    PickerChangeHandlerContext,
} from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { SHORT_DATE_FORMAT } from '@npi/buddy-utils';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/en-gb';

interface DateRangePickerProps {
    value: [Dayjs, Dayjs];
    onChange: (
        value: DateRange<Dayjs>,
        context: PickerChangeHandlerContext<DateRangeValidationError>
    ) => void;
    minDate?: Dayjs;
    maxDate?: Dayjs;
    sx?: SxProps;
    disableFuture?: boolean;
    label?: string;
}

const defaultSx: SxProps = {
    '.MuiPickersInputBase-input': {
        height: '9px',
    },
    '.MuiPickersInputBase-root': { height: '40px' },
    '.MuiPickersOutlinedInput-root': {
        '& fieldset': { borderColor: '#F39E4E' },
        '&:hover fieldset': {
            borderColor: '#F39E4E !important',
        },
    },
};

const CustomDateRangePicker = ({
    value,
    minDate,
    maxDate,
    onChange,
    label = '',
    sx = defaultSx,
}: DateRangePickerProps & { 'data-testid'?: string }) => {
    const { palette } = useTheme();

    return (
        <>
            {label && (
                <FormLabel
                    sx={{
                        marginBottom: '8px',
                        color: palette.common.black,
                        fontWeight: 600,
                    }}
                >
                    {label}
                </FormLabel>
            )}

            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                <DateRangePicker
                    format={SHORT_DATE_FORMAT}
                    minDate={minDate}
                    maxDate={maxDate}
                    value={value}
                    sx={sx}
                    onChange={onChange}
                />
            </LocalizationProvider>
        </>
    );
};

export default CustomDateRangePicker;
